<template>
    <div class="size-full relative z-0 rounded-card overflow-hidden">
        <div ref="slot" class="size-full" :style="iframeHeight">
            <slot />
        </div>
        <div
            v-if="useCookiebot && typeOfCookieBlocked"
            :class="[
                `cookieconsent-optout-${typeOfCookieBlocked} absolute inset-0 z-popover size-full bg-primary text-primary-text flex items-center justify-center rounded-card p-10 text-lg`,
            ]"
        >
            <div class="text-center">
                <p
                    v-text="
                        $lang.get(
                            'To watch this content you have to update your cookie preferences to allow :type cookies',
                            {
                                type: typeOfCookieTranslation,
                            }
                        )
                    "
                />
                <button
                    @click="renewCookieBot"
                    class="mt-4 underline hover:opacity-75 transition-opacity duration-button-hover"
                    v-text="$lang.get('Update cookie preferences')"
                />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlockedIframeWrapper',

    data() {
        return {
            typeOfCookieBlocked: null,
            typeOfCookieBlocked: null,
            iframeHeight: null,
        }
    },

    computed: {
        useCookiebot() {
            return !!import.meta.env.VITE_COOKIEBOT_UUID
        },

        typeOfCookieTranslation() {
            if (this.typeOfCookieBlocked === 'marketing') {
                return this.$lang.get('marketing')
            } else if (this.typeOfCookieBlocked === 'statistics') {
                return this.$lang.get('statistics')
            } else if (this.typeOfCookieBlocked === 'preferences') {
                return this.$lang.get('preferences')
            }
            return null
        },
    },

    mounted() {
        this.getIframeInformation()
    },

    methods: {
        getIframeInformation() {
            let slot = this.$refs.slot
            if (slot && this.useCookiebot) {
                let iframe = slot.querySelector('iframe')
                if (iframe) {
                    this.typeOfCookieBlocked =
                        iframe.getAttribute('data-cookieconsent')

                    let height = iframe.getAttribute('height')
                    if (height) {
                        this.iframeHeight = { height: height + 'px' }
                    }
                }
            }
        },

        renewCookieBot() {
            Cookiebot.renew()
        },
    },
}
</script>
